export const scrollLock = (action) => document.documentElement.classList[action]('scroll-lock');
